export const entitySchemaDataTypes = [
    'text',
    'numeric',
    'integer',
    'boolean',
    'timestamp',
    'date',
    'time',
    'jsonb',
    'reference'
];
//# sourceMappingURL=schemaDataTypes.js.map